import { IRechnungsposition, IRechnungspositionenResponse, DokumentenStatus } from '../../../models/ApiTypes';
import * as React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { Table, Button } from 'react-bootstrap';
import Callout from '../../site/Callout';

import { ApiStore } from '../../../stores/ApiStore';
import { bind, inject } from '../../../utils/decorators';
import { VorgangStore } from '../../../stores/VorgangStore';
import { AuftragStore } from '../../../stores/AuftragStore';
import Rechnungsposition from './Rechnungsposition';
import DienstleistungsUebersicht from './DienstleistungsUebersicht';

interface IDienstleistungsnachweisSammelrechnungProps {
  vorgangId: string;
  onTriggerDocumentRefresh?: () => void;
}

/**
 * Komponente zur Auswahl der im Auftrag abzurechnenden Positionen als Basis für die Sammelabrechnung
 * Anders als beim normalen Dienstleistungsnachweis, wird dieser nur von bestimmten an die DIQ Zert angebundenen Nutzern verwendet
 * Die hier erfassten Daten bilden später die Grundlage für die z.B. monatliche
 */
@observer
export default class DienstleistungsnachweisSammelrechnung extends React.Component<IDienstleistungsnachweisSammelrechnungProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;
  @inject(AuftragStore) auftragStore: AuftragStore;

  @observable dokumentStatus: DokumentenStatus = DokumentenStatus.NichtVorhanden;
  @observable vorhandenePositionen: IRechnungspositionenResponse;
  @observable gewaehltePositionen: IRechnungspositionenResponse = [];

  componentDidMount() {
    this.loadDienstleistungsnachweis();
  }

  async loadDienstleistungsnachweis() {
    let dienstleistung: string = '';
    if (this.vorgangStore.vorgang) {
      dienstleistung = this.vorgangStore.vorgang.kuerzel_dienstleistung;
    }
    let rechnungspositionen = await this.apiStore.rechnungspositionenDienstleistung(dienstleistung);
    if (rechnungspositionen.ok) {
      this.setRechnungspositionen(rechnungspositionen.json);
    }
  }

  @bind @action setzeDokumentStatus(status: DokumentenStatus) {
    this.dokumentStatus = status;
  }

  @bind @action setRechnungspositionen(rechnungspositionen: IRechnungspositionenResponse) {
    this.vorhandenePositionen = rechnungspositionen;
  }

  @bind async rechnungErzeugen() {
    this.setzeDokumentStatus(DokumentenStatus.Angefordert);

    // TODO: Anzahl direkt setzen
    // TODO: Unschöner Code, Kategorie + Sortierung u.U. nicht eindeutig
    this.vorhandenePositionen.forEach((position) => position.anzahl = this.gewaehltePositionen.filter((el) => el.kuerzel_dienstleistung === position.kuerzel_dienstleistung && el.sortierung === position.sortierung).length );

    const response = await this.apiStore.sammelRechnungErzeugen(this.props.vorgangId, this.vorhandenePositionen);
    if (response.ok) {
      if (this.props.onTriggerDocumentRefresh) {
        this.props.onTriggerDocumentRefresh();
      }
      this.vorgangStore.loadVorgang(this.props.vorgangId);
      this.setzeDokumentStatus(DokumentenStatus.Erzeugt);
    }
  }

  @bind @action setAnzahlHandler(anzahl: number, position: IRechnungsposition) {
    // Alle bestehenden Einträge der geänderten Position entfernen...
    this.gewaehltePositionen = this.gewaehltePositionen.filter((element) => element.bezeichnung !== position.bezeichnung);
    // und die neue Position so oft wie gefordert hinzufügen.
    let neuePositionen = [];
    for (let i = 0; i < anzahl; ++i) {
      neuePositionen.push(position);
    }
    this.gewaehltePositionen = this.gewaehltePositionen.concat(neuePositionen);
  }

  render() {
    return (
      <div className="maxwidth">
        <Callout bsStyle="success">
          <p>Bitte wählen Sie hier die Dienstleistungen aus die Sie in diesem Auftrag erbracht haben.</p>
          <p>Diese Auswahl ist Grundlage für die Erstellung einer Sammelrechnung durch die DIQ Zert GmbH</p>
          <p>Es gelten dabei die <a href="https://diq-zert.de/de/agb/">Allgemeinen Geschäftsbedingungen der DIQ Zert GmbH (AGB)</a>.</p>
        </Callout>

        <DienstleistungsUebersicht auftrag={this.auftragStore.auftrag} />

        <h3>
              Auswahl der Dienstleistungen
        </h3>

        {!this.vorhandenePositionen ?
          <div>lade Positionen...</div> :
          <div className="dienstleistungsnachweis">
            <Table striped={true} bordered={false} condensed={true} hover={true} className="dienstleistungsnachweis-eingabe">
              <thead>
                <tr>
                  <th>Position</th>
                  <th className="text-center">Anzahl</th>
                </tr>
              </thead>
              <tbody>
                {this.vorhandenePositionen.map((position, index) =>
                  <Rechnungsposition
                    key={index}
                    position={position}
                    anzahl={this.gewaehltePositionen.filter((filterposition) => (filterposition.bezeichnung === position.bezeichnung)).length}
                    setAnzahlHandler={this.setAnzahlHandler}
                    preiseAnzeigen={false}
                  />
                )}
              </tbody>
            </Table>
          </div>
        }

        <Callout bsStyle="warning">
          <h4>Auswahl bestätigen</h4>
          <p>Übermittelt die ausgewählten Positionen. Der Vorgang wird dadurch abgeschlossen, <b>eine nachträgliche Korrektur ist nicht mehr möglich!</b></p>
          <div>
            {this.dokumentStatus === DokumentenStatus.NichtVorhanden && this.vorhandenePositionen && (
              <div className="text-right">
                <Button bsStyle="warning" onClick={this.rechnungErzeugen} disabled={this.gewaehltePositionen.length === 0}>Bestätigen</Button>
              </div>)
            }
            {this.dokumentStatus === DokumentenStatus.Angefordert && <p>Die Daten werden übermittelt...</p>}
          </div>
        </Callout>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/abrechnung/DienstleistungsnachweisSammelrechnung.tsx